interface Size { width: number; height: number }
interface BackgroundCamera { x: number; y: number; scale: number }

/** MapView.as keeps sky zoom at sqrt(map zoom) and maps camera travel onto
 * the sky's shorter scroll range. Cover is the viewport adaptation: a single
 * original image keeps its aspect ratio and never exposes the canvas edges.
 */
export function backgroundViewport(viewport: Size, image: Size, world: Size, camera: BackgroundCamera, baseScale: number) {
  const scale = Math.max(viewport.width / image.width, viewport.height / image.height,
    Math.sqrt(camera.scale * baseScale));
  const width = image.width * scale, height = image.height * scale;
  const progress = (view: number, extent: number, center: number) => {
    const travel = extent * camera.scale - view;
    return travel > 0 ? Math.max(0, Math.min(1, (center * camera.scale - view / 2) / travel)) : .5;
  };
  return { x: (viewport.width - width) * progress(viewport.width, world.width, camera.x),
    y: (viewport.height - height) * progress(viewport.height, world.height, camera.y), width, height };
}
